module.exports = __webpack_public_path__ + "img/twitter.4d3a75d7.svg";